/* eslint-disable no-debugger */
import React, { useState, useEffect } from 'react';
import { Box, Typography, Collapse, Breadcrumbs, Link, IconButton } from '@mui/material';
import { NavigateNext, Home, AccountCircle } from '@mui/icons-material';
import logo from '../../Assets/Logos/logo-desk.svg';
import okoLogo from '../../Assets/Logos/OKO_New_Logo.svg';
// import AdminPopUp from '../../Components/TopHeader/small-right-popUp-admin.component';
import ProfilePopup from '../../Components/TopHeader/ProfilePopup';
import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from '../../common/functions/log_out.function';
import { notify } from '../../common/functions/react-toastify.function';
import { useNavigate } from 'react-router-dom';
import AppsIcon from '@mui/icons-material/Apps';
import { useLocation } from 'react-router-dom';
import circleIcon from '../../Assets/AlertIcon/circle.svg';
import FilterDrawer from '../../Components/FilterDrawer';
import TemporaryDrawer from './left_drawer_mui_component';
import { useAtom, useSetAtom, useAtomValue } from 'jotai';
import { getPermissions } from '../../common/functions/get_permissions_from_storage.function';
import {
  hasAnyPermission,
  hasNetworkMonitoringPermissions,
  NETWORK_MONITORING_PERMISSIONS,
  INVENTORY_MANAGEMENT_PERMISSIONS,
  USER_MANAGEMENT_PERMISSIONS,
  PARTNER_NETWORK_PERMISSIONS,
  KMZ_PERMISSIONS,
  RING_PLANNING_PERMISSIONS,
  FIBER_POP_LIST_PERMISSIONS,
  hasApprovalPersonsSystemInvoiceManagementAccess,
  hasLoginLockoutManagementAccess,
  hasInvoiceApproverAssignmentsModuleAccess,
  hasSystemInvoiceApproverAssignmentsModuleAccess,
} from '../../common/functions/permission_utils.function';

// Breadcrumb component
const FancyBreadcrumb = ({ moduleName, subModuleName, onHomeClick, onModuleClick }) => {
  return (
    <Breadcrumbs
      separator={
        <NavigateNext
          fontSize="small"
          sx={{
            color: '#666',
            transition: 'all 0.2s ease',
            '&:hover': {
              color: '#fff',
              transform: 'scale(1.1)',
            },
          }}
        />
      }
      aria-label="breadcrumb"
      sx={{
        '& .MuiBreadcrumbs-separator': {
          margin: '0 8px',
        },
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Link
        component="button"
        variant="body1"
        onClick={onHomeClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          color: '#999',
          textDecoration: 'none',
          fontSize: '14px',
          fontWeight: 400,
          transition: 'color 0.2s ease',
          lineHeight: 1,
          '&:hover': {
            color: '#fff',
            textDecoration: 'none',
          },
        }}
      >
        <Home sx={{ fontSize: '16px' }} />
        Home
      </Link>

      {moduleName && (
        <Link
          component="button"
          variant="body1"
          onClick={onModuleClick}
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#ccc',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 500,
            transition: 'color 0.2s ease',
            lineHeight: 1,
            '&:hover': {
              color: '#fff',
              textDecoration: 'none',
            },
          }}
        >
          {moduleName}
        </Link>
      )}

      {subModuleName && (
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 600,
            textDecoration: 'none',
            lineHeight: 1,
            margin: 0,
            padding: 0,
          }}
        >
          {subModuleName}
        </Typography>
      )}
    </Breadcrumbs>
  );
};

export const TopHeaderBar = ({
  state,
  list,
  // Additional props for filter functionality
  totalAlarms,
  value,
  setValue,
  toggleDrawer,
  applyFilters,
  selectedTab,
  regions,
  cities,
  rings,
  sites,
  links,
  region,
  setRegion,
  city,
  setCity,
  ring,
  setRing,
  site,
  setSite,
  link,
  setLink,
  handleRegionChange,
  handleCityChange,
  handleSiteChange,
  handleLinkChange,
  handleReset,
  handleApply,
}) => {
  const [anchor, setAnchor] = useState(null);
  const location = useLocation();
  const pathName = location.pathname.split('/').pop();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showModuleName, setShowModuleName] = useState(true);
  const [showBreadcrumb, setShowBreadcrumb] = useState(true);
  const [profileAnchor, setProfileAnchor] = useState(null);

  // Get user permissions
  const permissions = getPermissions();
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  // const open = useAtomValue(openDrawerLeft);

  const environment = process.env.REACT_APP_ENVIRONMENT;

  // Effect to handle filter visibility and module name display
  useEffect(() => {
    if (state && state?.right) {
      setShowFilters(true);
      setShowModuleName(false);
      setShowBreadcrumb(false);
    } else {
      setShowFilters(false);
      setShowModuleName(!showBreadcrumb); // Hide module name only when breadcrumb is shown
      setShowBreadcrumb(true);
    }
  }, [state, showBreadcrumb]);

  const handleLogout = async () => {
    try {
      const result = await logout();
      navigate('/');
      notify('success', result.message);
    } catch (error) {
      notify('error', error?.response?.data?.message);
      navigate('/');
    }
  };
  const openDrawerLeft = (newOpen) => () => {
    setOpen(newOpen);
  };
  const handleAppPopupClick = (event) => {
    setAnchor(anchor ? null : event.currentTarget);
  };
  const handleProfileClick = (event) => {
    setProfileAnchor(profileAnchor ? null : event.currentTarget);
  };
  const handleProfileClose = () => {
    setProfileAnchor(null);
  };
  const handleTabSelection = (tabValue) => {
    sessionStorage.setItem('selectedTab', tabValue);
    navigate('/fibers');
  };

  // Function to check if user has permission for a specific module/sub-module
  const hasPermissionForPath = (path) => {
    if (path.includes('/userManagement')) {
      return hasAnyPermission(permissionNames, USER_MANAGEMENT_PERMISSIONS);
    } else if (path.includes('/fiberSite') || path.includes('/fiberSitePlanning')) {
      return hasAnyPermission(permissionNames, ['fiberSite']);
    } else if (path.includes('/randb') || path.includes('/ranDb')) {
      return hasAnyPermission(permissionNames, ['ranDb']);
    } else if (path.includes('/tenantManagement')) {
      return hasAnyPermission(permissionNames, USER_MANAGEMENT_PERMISSIONS);
    } else if (path.includes('/rov')) {
      return true; // Home page is accessible to all authenticated users
    } else if (path.includes('/networkAlarms') || path.includes('/network_alarms')) {
      return hasAnyPermission(permissionNames, ['Network Alarms']);
    } else if (path.includes('/fibers')) {
      return hasNetworkMonitoringPermissions(permissionNames);
    } else if (path.includes('/networkLayer')) {
      return hasAnyPermission(permissionNames, ['Network Layer Visualization']);
    } else if (path.includes('/inventory')) {
      return hasAnyPermission(permissionNames, ['Inventory']);
    } else if (path.includes('/leasedFiber')) {
      return hasAnyPermission(permissionNames, ['Leased Fiber Pair']);
    } else if (path.includes('/networkPlanning/kmzPlanning')) {
      return hasAnyPermission(permissionNames, KMZ_PERMISSIONS);
    } else if (path.includes('/kmzMap') || path.includes('/kmz')) {
      return hasAnyPermission(permissionNames, PARTNER_NETWORK_PERMISSIONS);
    } else if (path.includes('/networkPlanning/ringPlanning')) {
      return hasAnyPermission(permissionNames, RING_PLANNING_PERMISSIONS);
    } else if (path.includes('/networkPlanning/fiberPopList')) {
      return hasAnyPermission(permissionNames, FIBER_POP_LIST_PERMISSIONS);
    } else if (path.includes('/invoiceAttachmentManagement')) {
      return permissionNames?.includes('Invoice Attachment Management');
    } else if (
      path.includes('/purchaseOrderManagement') ||
      path.includes('/poWorkflowManagement')
    ) {
      return permissionNames?.includes('Admin Invoice Management');
    } else if (
      path.includes('/systemPurchaseOrderManagement') ||
      path.includes('/systemPoWorkflowManagement')
    ) {
      return permissionNames?.includes('System Invoice Management');
    } else if (path.includes('/approvalPersonsInvoiceManagement')) {
      return permissionNames?.includes('Approval Persons Invoice Management');
    } else if (path.includes('/approvalPersonsSystemInvoiceManagement')) {
      return hasApprovalPersonsSystemInvoiceManagementAccess(permissionNames);
    } else if (path.includes('/vendorInvoiceManagement')) {
      return permissionNames?.includes('Vendor Invoice Management');
    } else if (path.includes('/systemInvoiceManagementVendor')) {
      return permissionNames?.includes('System Invoice Management Vendor');
    } else if (path.includes('/jazzSupport')) {
      return permissionNames?.includes('Jazz Support');
    } else if (path.includes('/loginLockoutManagement')) {
      return hasLoginLockoutManagementAccess(permissionNames);
    } else if (path.includes('/systemInvoiceApproverAssignments')) {
      return hasSystemInvoiceApproverAssignmentsModuleAccess(permissionNames);
    } else if (path.includes('/invoiceApproverAssignments')) {
      return hasInvoiceApproverAssignmentsModuleAccess(permissionNames);
    }

    return false;
  };

  // Function to get module and sub-module names based on current path with permission checks
  const getModuleInfo = () => {
    const path = location.pathname;

    // Check if user has permission for current path
    if (!hasPermissionForPath(path)) {
      return { moduleName: null, subModuleName: null };
    }

    if (path.includes('/userManagement')) {
      return { moduleName: 'Access Control', subModuleName: null };
    } else if (path.includes('/fiberSite') || path.includes('/fiberSitePlanning')) {
      return { moduleName: 'Inventory Management', subModuleName: 'FTTS Site List' };
    } else if (path.includes('/randb') || path.includes('/ranDb')) {
      return { moduleName: 'Inventory Management', subModuleName: 'RAN DB' };
    } else if (path.includes('/tenantManagement')) {
      return { moduleName: 'Tenant Management', subModuleName: null };
    } else if (path.includes('/rov')) {
      return { moduleName: null, subModuleName: null };
    } else if (path.includes('/networkAlarms') || path.includes('/network_alarms')) {
      return { moduleName: 'Network Alarms', subModuleName: null };
    } else if (path.includes('/fibers')) {
      return { moduleName: 'Network Monitoring', subModuleName: null };
    } else if (path.includes('/networkLayer')) {
      return { moduleName: 'Inventory Management', subModuleName: 'Network Layer Visualization' };
    } else if (path.includes('/inventory')) {
      return { moduleName: 'Inventory Management', subModuleName: 'OFC Inventory' };
    } else if (path.includes('/leasedFiber')) {
      return { moduleName: 'Inventory Management', subModuleName: 'Leased Fiber Pair' };
    } else if (path.includes('/networkPlanning/kmzPlanning')) {
      return { moduleName: 'Network Planning', subModuleName: 'KMZ' };
    } else if (path.includes('/kmzMap') || path.includes('/kmz')) {
      return { moduleName: 'Partner Network', subModuleName: null };
    } else if (path.includes('/networkPlanning/ringPlanning')) {
      return { moduleName: 'Network Planning', subModuleName: 'Ring Planning' };
    } else if (path.includes('/networkPlanning/fiberPopList')) {
      return { moduleName: 'Inventory Management', subModuleName: 'Fiber Pop List' };
    } else if (path.includes('/purchaseOrderManagement')) {
      return { moduleName: 'Invoice Management', subModuleName: 'Purchase Order Management' };
    } else if (path.includes('/poWorkflowManagement')) {
      return { moduleName: 'Invoice Management', subModuleName: 'Vendor Invoice Management' };
    } else if (path.includes('/invoiceAttachmentManagement')) {
      return {
        moduleName: 'Invoice Management',
        subModuleName: 'Invoice Attachment Management',
      };
    } else if (path.includes('/systemPurchaseOrderManagement')) {
      return {
        moduleName: 'System Invoice Management',
        subModuleName: 'Purchase Order Management',
      };
    } else if (path.includes('/systemPoWorkflowManagement')) {
      return {
        moduleName: 'System Invoice Management',
        subModuleName: 'Vendor Invoice Management',
      };
    } else if (path.includes('/approvalPersonsInvoiceManagement')) {
      return { moduleName: 'Invoice Management', subModuleName: null };
    } else if (path.includes('/approvalPersonsSystemInvoiceManagement')) {
      return {
        moduleName: 'System Invoice Management',
        subModuleName: null,
      };
    } else if (path.includes('/vendorInvoiceManagement')) {
      return { moduleName: 'Invoice Management', subModuleName: null };
    } else if (path.includes('/systemInvoiceManagementVendor')) {
      return { moduleName: 'Invoice Management', subModuleName: null };
    } else if (path.includes('/jazzSupport')) {
      return { moduleName: 'Jazz Support', subModuleName: null };
    } else if (path.includes('/loginLockoutManagement')) {
      return { moduleName: 'Login Lockout', subModuleName: null };
    } else if (path.includes('/systemInvoiceApproverAssignments')) {
      return { moduleName: 'System Invoice Approver Assignments', subModuleName: null };
    } else if (path.includes('/invoiceApproverAssignments')) {
      return { moduleName: 'Invoice Approver Assignments', subModuleName: null };
    }

    return { moduleName: 'Network Monitoring', subModuleName: null };
  };

  const { moduleName, subModuleName } = getModuleInfo();
  const displayModuleName =
    moduleName === 'Partner Network' ? 'Comprehensive Route Planning' : moduleName;
  const displaySubModuleName =
    subModuleName === 'KMZ' ? 'KMZ Upload with Network Overlay' : subModuleName;

  const handleHomeClick = () => {
    navigate('/rov');
  };

  const handleModuleClick = () => {
    // Navigate to the main module page based on permissions
    if (moduleName === 'Inventory Management') {
      // Check if user has any inventory management permissions
      const hasInventoryPermission = hasAnyPermission(permissionNames, [
        'fiberSite',
        'ranDb',
        'Inventory',
        'Leased Fiber Pair',
        'Network Layer Visualization',
        'Fiber Pop List',
      ]);
      if (hasInventoryPermission) {
        navigate('/rov'); // Navigate to landing page where they can see available modules
      }
    } else if (moduleName === 'Network Monitoring') {
      if (hasNetworkMonitoringPermissions(permissionNames)) {
        navigate('/fibers');
      }
    } else if (moduleName === 'Access Control') {
      if (hasAnyPermission(permissionNames, USER_MANAGEMENT_PERMISSIONS)) {
        navigate('/userManagement');
      }
    } else if (moduleName === 'Tenant Management') {
      if (hasAnyPermission(permissionNames, USER_MANAGEMENT_PERMISSIONS)) {
        navigate('/tenantManagement');
      }
    } else if (moduleName === 'Network Alarms') {
      if (hasAnyPermission(permissionNames, ['Network Alarms'])) {
        navigate('/networkAlarms');
      }
    } else if (moduleName === 'Partner Network') {
      if (hasAnyPermission(permissionNames, PARTNER_NETWORK_PERMISSIONS)) {
        navigate('/kmzMap');
      }
    } else if (moduleName === 'Network Planning') {
      // Check if user has any network planning permissions
      const hasNetworkPlanningPermission = hasAnyPermission(
        permissionNames,
        [PARTNER_NETWORK_PERMISSIONS, KMZ_PERMISSIONS, RING_PLANNING_PERMISSIONS].flat()
      );
      if (hasNetworkPlanningPermission) {
        navigate('/rov'); // Navigate to landing page where they can see available modules
      }
    } else if (moduleName === 'Invoice Management') {
      if (location.pathname.includes('/invoiceAttachmentManagement')) {
        navigate('/rov', { state: { openLandingInvoiceManagement: true } });
        return;
      }
      // Vendor Invoice Management: middle crumb returns to the module root (preserve tab)
      if (location.pathname.includes('/poWorkflowManagement')) {
        const isMainPage =
          location.pathname === '/poWorkflowManagement' ||
          location.pathname === '/poWorkflowManagement/';
        if (isMainPage) {
          return;
        }
        const tab = (location.state?.fromTab || 'action-required').toString().trim();
        const suffix = tab && tab !== 'action-required' ? `?tab=${encodeURIComponent(tab)}` : '';
        navigate(`/poWorkflowManagement${suffix}`);
        return;
      }
      // Purchase Order Management: middle crumb goes to landing with invoice dropdown open
      if (location.pathname.includes('/purchaseOrderManagement')) {
        navigate('/rov', { state: { openLandingInvoiceManagement: true } });
        return;
      }
      if (permissionNames?.includes('Admin Invoice Management')) {
        navigate('/purchaseOrderManagement');
      } else if (permissionNames?.includes('Approval Persons Invoice Management')) {
        navigate('/approvalPersonsInvoiceManagement');
      } else if (permissionNames?.includes('Vendor Invoice Management')) {
        navigate('/vendorInvoiceManagement');
      } else if (permissionNames?.includes('System Invoice Management Vendor')) {
        navigate('/systemInvoiceManagementVendor');
      }
    } else if (moduleName === 'System Invoice Management') {
      if (hasApprovalPersonsSystemInvoiceManagementAccess(permissionNames)) {
        navigate('/approvalPersonsSystemInvoiceManagement');
      } else if (permissionNames?.includes('System Invoice Management')) {
        navigate('/systemPurchaseOrderManagement');
      }
    } else if (moduleName === 'Jazz Support') {
      if (permissionNames?.includes('Jazz Support')) {
        navigate('/jazzSupport');
      }
    } else if (moduleName === 'Login Lockout') {
      if (hasLoginLockoutManagementAccess(permissionNames)) {
        navigate('/loginLockoutManagement');
      }
    } else if (moduleName === 'System Invoice Approver Assignments') {
      if (hasSystemInvoiceApproverAssignmentsModuleAccess(permissionNames)) {
        navigate('/systemInvoiceApproverAssignments');
      }
    } else if (moduleName === 'Invoice Approver Assignments') {
      if (hasInvoiceApproverAssignmentsModuleAccess(permissionNames)) {
        navigate('/invoiceApproverAssignments');
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#192126',
          border: '1px solid #333333',
          color: '#fff',
          height: '70px',
          fontFamily: 'Inter, sans-serif',
        }}
      >
        {/* <AdminPopUp anchor={anchor} setAnchor={setAnchor} handleTabSelection={handleTabSelection} /> */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: '12px',
            mx: '16px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <img
              alt=""
              src={environment === 'demo' ? okoLogo : logo}
              style={{ height: '50px', cursor: 'pointer' }}
              onClick={() => navigate('/rov')}
            />

            {/* Always visible Circle Icon - Hide on dashboard page */}
            {pathName !== 'rov' && (
              <Box
                sx={{
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  backgroundColor: '#3A474F',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#4A5A65',
                    transform: 'scale(1.1)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                  },
                  '&:active': {
                    transform: 'scale(0.95)',
                  },
                }}
                onClick={openDrawerLeft(true)}
              >
                <img
                  src={circleIcon}
                  alt="Circle Icon"
                  style={{
                    width: '16px',
                    height: '16px',
                    transition: 'all 0.2s ease',
                  }}
                />
              </Box>
            )}

            {/* Breadcrumb */}
            <Collapse
              in={showBreadcrumb && !open}
              timeout={300}
              sx={{
                minWidth: 0,
                display: showFilters ? 'none' : 'block',
              }}
            >
              {moduleName && (
                <FancyBreadcrumb
                  moduleName={displayModuleName}
                  subModuleName={displaySubModuleName}
                  onHomeClick={handleHomeClick}
                  onModuleClick={handleModuleClick}
                />
              )}
            </Collapse>

            {/* Original Module Name - Only show when breadcrumb is not available */}
            {/* <Collapse
              in={showModuleName}
              timeout={300}
              sx={{
                minWidth: 0,
                display: showFilters ? 'none' : 'block',
              }}
            >
              {moduleName && (
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: '18px',
                    fontWeight: 500,
                    fontFamily: 'Inter',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {moduleName}
                </Typography>
              )}
            </Collapse> */}
          </Box>

          <Collapse in={showFilters} timeout={300} sx={{ flex: 1, mx: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              {list ? (
                list('right')
              ) : (
                <FilterDrawer
                  selectedTab={selectedTab}
                  regions={regions}
                  cities={cities}
                  rings={rings}
                  sites={sites}
                  links={links}
                  region={region}
                  setRegion={setRegion}
                  city={city}
                  setCity={setCity}
                  ring={ring}
                  setRing={setRing}
                  site={site}
                  setSite={setSite}
                  link={link}
                  setLink={setLink}
                  handleRegionChange={handleRegionChange}
                  handleCityChange={handleCityChange}
                  handleSiteChange={handleSiteChange}
                  handleLinkChange={handleLinkChange}
                  handleReset={handleReset}
                  handleApply={handleApply}
                />
              )}
            </Box>
          </Collapse>

          <Box
            sx={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              {pathName === 'rov' ? (
                <LogoutIcon onClick={handleLogout} />
              ) : (
                <IconButton
                  onClick={handleProfileClick}
                  sx={{
                    color: '#fff',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      transform: 'scale(1.1)',
                    },
                    '&:active': {
                      transform: 'scale(0.95)',
                    },
                  }}
                >
                  <AccountCircle sx={{ fontSize: 28 }} />
                </IconButton>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Profile Popup */}
      <ProfilePopup
        anchor={profileAnchor}
        setAnchor={setProfileAnchor}
        onClose={handleProfileClose}
      />

      {/* TemporaryDrawer - Always available */}
      <TemporaryDrawer open={open} toggleDrawer={openDrawerLeft} />
    </>
  );
};
